document.addEventListener("click", function(event) {
    if (event.target.classList.contains("minicart-quantity-plus")) {
        const button = event.target;
        const container = button.closest(".cart-sidebar-item-btns");
        const input = container.querySelector(".quantity-input");
        const currentValue = parseInt(input.value) || 0;
        const maxValue = parseInt(input.getAttribute("data-max"));
        const variantId = button.getAttribute("data-variant-id");

        

        // Disable button if about to hit or has hit max
        if (currentValue + 1 >= maxValue) {
            button.classList.add("disabled");
        }

        // ✅ Delay check for post-AJAX update
        setTimeout(() => {
            const updatedInput = document.querySelector(`.quantity-input[data-variant-id="${variantId}"]`);
            const newValue = parseInt(updatedInput.value);
            const message = document.querySelector(`.max-limit-message[data-variant-id="${variantId}"]`);

            // ✅ Only show if user tried to exceed max
            if (newValue >= maxValue && currentValue >= maxValue && message) {
                message.style.display = "block";
                message.style.opacity = "1";

                setTimeout(() => {
                    message.style.opacity = "0";
                    setTimeout(() => {
                        message.style.display = "none";
                    }, 1000); // fade out
                }, 5000); // show for 10s
            }
        }, 1000); // Delay for AJAX/cart to complete
    }
});

$(document).ready(function () {
    // Handle item removal
    $(document).on("click", ".item-remove", function (e) {
        e.preventDefault();

        // Get variant ID from the clicked button
        const variantId = $(this).attr("variant-id");

        if (!variantId) {
            console.error("Error: Variant ID is missing.");
            alert("Unable to remove item. Please try again.");
            return;
        }

        $(this).addClass("removing");

        // Perform AJAX request to remove the item
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                id: variantId, // Use the variant ID
                quantity: 0,   // Setting quantity to 0 removes the item
            },
            dataType: "json",
            success: function (response) {
                // Remove the item from the DOM
                const $parentItem = $(`[variant-id="${variantId}"]`).closest(".cart-sidebar-item");
                $parentItem.fadeOut(300, function () {
                    $(this).remove();

                    // Handle empty cart
                    if (response.item_count === 0) {
                        console.log("Cart is now empty.");
                        $(".cart-sidebar-total-price, .cart-sidebar-subtotal-price").text("$0.00");
                        $(".cart-sidebar-items").html("<p>Your cart is empty.</p>");
                    }
                });

                // Update cart counts
                updateCartItemCounts(response.item_count);

                // Refresh the cart drawer
                updateCartDrawer();
            },
            error: function (xhr, status, error) {
                console.error("Error removing item:", xhr.responseJSON || xhr.responseText);
                alert("Failed to remove the item. Please try again.");
            },
            complete: function () {
                // Remove the "removing" class to reset the button's state
                $(".item-remove").removeClass("removing");
            },
        });
    });

    // Update cart item counts
    function updateCartItemCounts(itemCount) {
        $(".cart-count").text(itemCount);
    }

    // Refresh cart drawer content
    function updateCartDrawer() {
        $.ajax({
            url: "/?section_id=cartdrawer",
            method: "GET",
            success: function (data) {
                // Update cart sidebar content
                const html = document.createElement("div");
                html.innerHTML = data;
                const newCartContent = html.querySelector(".cart-sidebar-inner").innerHTML;
                $(".cart-sidebar-inner").html(newCartContent);

                // Reapply listeners for the updated cart drawer
                addCartDrawerListeners();
            },
            error: function () {
                console.error("Error refreshing cart drawer.");
            },
        });
    }

    
});


// JavaScript to handle clicks outside the sidebar
document.addEventListener('click', function(event) {
    // Get the sidebar element
    var sidebar = document.querySelector('.cart-sidebar');
    var sidebar_parent = document.querySelector('.cart-sidebar-parent');
    
    // Check if the clicked element is outside the sidebar
    //if (!sidebar.contains(event.target)) {
        // If clicked outside, add 'hidden' class and remove 'active' class
    //    sidebar.classList.add('hidden');
    //    sidebar_parent.classList.remove('active');
    //}
});



function OpenCartDrawer() {
    setTimeout(() => {
        document.querySelector('.cart-sidebar-parent').classList.add('active');
        document.querySelector('.cart-sidebar').classList.remove('hidden');
    }, 100); // Delay of 500 milliseconds (adjust as needed)
}


function CloseCartDrawer() {
    document.querySelector('.close-sidebar').addEventListener('click', function() {
    
            document.querySelector('.cart-sidebar').classList.add('hidden');
            document.querySelector('.cart-sidebar-parent').classList.remove('active');
        }); 
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
    const res = await fetch("/?section_id=cartdrawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    
    const newBox = html.querySelector(".cart-sidebar-inner").innerHTML;
    document.querySelector(".cart-sidebar-inner").innerHTML = newBox;
    
    addCartDrawerListeners();
    
}



function addCartDrawerListeners() {
  // Update quantities
  document.querySelectorAll(".minicart-quantity button").forEach((button) => {
    button.addEventListener("click", async () => {
      // Get line item key
      const rootItem = button.closest(".cart-sidebar-item");
      const key = rootItem.getAttribute("data-line-item-key");

      // Get the input element and current quantity
      const input = button.parentElement.querySelector("input");
      const currentQuantity = Number(input.value);
      const isUp = button.classList.contains("minicart-quantity-plus");

      // Get the minimum and maximum quantity values from input attributes
      const minQuantity = Number(input.getAttribute("min")) || 1;
      const maxQuantity = Number(input.getAttribute("data-max"));

      // Calculate the new quantity within min and max bounds
      const newQuantity = isUp
        ? Math.min(currentQuantity + 1, maxQuantity)
        : Math.max(currentQuantity - 1, minQuantity);

      // Prevent the update if new quantity is the same as current
      if (newQuantity === currentQuantity) {
        return;
      }

      // Add the 'incrementing' class to button and parent container
      button.classList.add("incrementing");
      const btnContainer = rootItem.querySelector(".cart-sidebar-item-btns");
      if (btnContainer) {
        btnContainer.classList.add("updating");
      }

      // Perform the AJAX update without updating input value until response
      try {
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);

        // Set the input value to newQuantity once AJAX completes
        input.value = newQuantity;

        // Update cart drawer to reflect any further changes
        updateCartDrawer();

      } catch (error) {
        console.error("Error updating cart:", error);
      } finally {
        // Remove the 'incrementing' and 'updating' classes after update completes or fails
        button.classList.remove("incrementing");
        if (btnContainer) {
          btnContainer.classList.remove("updating");
        }
      }
    });
  });
}

addCartDrawerListeners();


document.addEventListener('DOMContentLoaded', function () {
  const waitForForm = () => {
    const productForm = document.querySelector('product-form form');
    if (!productForm) {
      setTimeout(waitForForm, 100); // Keep checking until it appears
      return;
    }

    productForm.addEventListener('submit', async function (event) {
      event.preventDefault();

      // Add to cart using fetch
      await fetch("/cart/add", {
        method: "POST",
        body: new FormData(productForm),
      });

      const intervalId = setInterval(async () => {
        const res = await fetch("/cart.js");
        const cart = await res.json();

        // Custom functions you’ve defined elsewhere
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();

        if (cart.item_count > 0) {
          OpenCartDrawer();

          // Dispatch event for recommendations
          document.dispatchEvent(new Event('cartSidebarOpened'));

          // Optional: close drawer after a timeout (if that's your flow)
          setTimeout(() => {
            CloseCartDrawer();
          }, 3000);

          clearInterval(intervalId);
        }
      }, 1000);
    });
  };

  waitForForm();

  // Recommendations section
  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(console.error);
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px',
    });

    observer.observe(productRecommendationsSection);
  }
});




